document.addEventListener('click',e=>{
 const toggle=e.target.closest('[data-mobile-toggle]');
 const nav=document.querySelector('[data-mobile-nav]');
 if(toggle&&nav) nav.classList.toggle('is-open');
 const link=e.target.closest('[data-mobile-nav] a');
 if(link&&nav) nav.classList.remove('is-open');
});
document.addEventListener('DOMContentLoaded',()=>{
 const search=document.querySelector('[data-search]');
 if(search){search.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.value.trim()) window.location.href='/search?q='+encodeURIComponent(e.target.value.trim())})}
});

// Page "Créer sur mesure" : ouvre une vraie vue dédiée sans dépendre d'une page Shopify à créer.
document.addEventListener('DOMContentLoaded',()=>{
  const params=new URLSearchParams(window.location.search);
  if(params.get('custom_project')!=='1') return;
  const store=document.getElementById('StorefrontContent');
  const custom=document.getElementById('CustomProjectContent');
  if(!store||!custom) return;
  store.hidden=true;
  custom.hidden=false;
  document.title='Créer sur mesure — Aux créa d’Alice';
  window.scrollTo(0,0);
});


// V21 : bouton de retour
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-back-button]').forEach(button=>{
    button.addEventListener('click',()=>{
      if(window.history.length>1){window.history.back();}
      else{window.location.href='/';}
    });
  });
});
